// Copyright (c) 2023 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.

'use strict';

export const chronik = {
    urls: [
        'https://chronik-native1.fabien.cash',
        'https://chronik.pay2stay.com/xec',
    ],
    txHistoryCount: 20,
    txHistoryPageSize: 20,
};
